import filter from "lodash/filter";
import React, { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";

import { deactivateCurrentAccount } from "../../../../../actions/shared/individualActions";
import { clearModal } from "../../../../../actions/shared/uiActions";
import { getCurrentIndividual } from "../../../../../selectors/individualSelectors";
import { getAllTeammates } from "../../../../../selectors/teammateSelectors";
import Button from "../../../../forms/custom/Button";
import ActionModalContainer from "../../../../General/ActionModal/ActionModalContainer";
import ActionModalContent from "../../../../General/ActionModal/ActionModalContent";
import ActionModalFooter from "../../../../General/ActionModal/ActionModalFooter";
import ActionModalHeader from "../../../../General/ActionModal/ActionModalHeader";

const determineRoleCount = (items, role) => filter(items, (item) => item.attributes.roles.includes(role)).length;

function DeactivateModal(props) {
  const [isSubmitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState(false);
  const dispatch = useDispatch();

  const handleClose = useCallback(() => dispatch(clearModal()), [dispatch]);
  const redirectPage = (link) => {
    handleClose();
    props.history.push(link);
  };

  const teammates = useSelector((state) => getAllTeammates(state));
  const currentIndividual = useSelector((state) => getCurrentIndividual(state));

  const shouldPreventDeactivation = () => {
    if (teammates.length === 1) {
      return false;
    }

    const teamManagerCount = determineRoleCount(teammates, "team_manager");
    const financeManagerCount = determineRoleCount(teammates, "finance_manager");

    const { teamManager, financeManager } = currentIndividual;

    return (
      (teamManagerCount === 1 && teamManager) ||
      (financeManagerCount === 1 && financeManager)
    );
  };

  const handleDeactiveCurrentAccount = () => {
    setSubmitting(true);

    if (!shouldPreventDeactivation()) {
      dispatch(deactivateCurrentAccount())
        .then(() => (window.location.href = "https://www.recruitifi.com/"))
        .catch((e) => {
          setErrors(e.response.data.errors);
          setSubmitting(false);
        });
    } else {
      setErrors("Must re-assign permissions");
      setSubmitting(false);
    }
  };

  return (
    <ActionModalContainer color="red">
      <ActionModalHeader
        title="Deactivate My Account"
        subtitle="This action cannot be undone"
      />
      <ActionModalContent>
        <div>
          <h5>Wait! Before you go:</h5>
          <ul>
            <li>
              If you are sick of getting emails you can change that,
              {" "}
              <span
                className="pseudo-link"
                style={{ color: "#008DAE" }}
                onClick={() => redirectPage("email")}
              >
                here
              </span>
              .
            </li>
            <li>
              If you are not getting the JobCasts you want you can change that,
              {" "}
              <span
                className="pseudo-link"
                style={{ color: "#008DAE" }}
                onClick={() => redirectPage("jobcast_matching")}
              >
                here
              </span>
              .
            </li>
            <li>Deactivating your account is final and cannot be undone.</li>
            <li>
              If you are the last Team Manager and/or Finance Manager on your
              team you must re-assign those permissions.
            </li>
          </ul>
          <p />
        </div>
      </ActionModalContent>
      <ActionModalFooter
        isSubmitting={isSubmitting}
        submissionError={Boolean(errors)}
        customErrorMessage={errors}
        customButtons={(
          <div>
            <Button
              color="blue"
              variant="primary"
              onClick={handleClose}
              disabled={isSubmitting}
              style={({
                padding: "0 26px 0 26px",
                margin: "0 4px",
              })}
            >
              Never mind
            </Button>
            <Button
              color="white"
              variant="secondary"
              onClick={handleDeactiveCurrentAccount}
              disabled={isSubmitting}
              style={({
                padding: "0 26px 0 26px",
                margin: "0 4px",
              })}
            >
              Deactivate
            </Button>
          </div>
        )}
      />
    </ActionModalContainer>
  );
}

export default withRouter(DeactivateModal);
